import { createAction, props } from '@ngrx/store';
import { BookModel } from '../models';

export const BOOKS_CLEAR_ACTION = createAction('[BOOKS] CLEAR');
export const BOOKS_ADD_ACTION = createAction('[BOOKS] ADD', props<{ payload: BookModel }>());
export const BOOKS_REMOVE_ACTION = createAction('[BOOKS] REMOVE', props<{ payload: string }>());
